var _filter, _filter2, _filter3, _pattern, _pattern2, _marker, _rect, _rect2, _line, _text, _text2, _rect3, _rect4, _rect5, _rect6, _g, _g2, _g3, _g4, _g5, _rect7, _text3, _circle, _text4, _circle2, _text5, _rect8, _line2, _rect9, _circle3, _line3, _text6, _g6, _rect10, _rect11, _path, _path2, _path3, _path4, _path5, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _rect12, _text7, _text8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodeEditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1400 900",
    width: 1400,
    height: 900,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f8fafc"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sidebarGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "canvasGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f8fafc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f1f5f9"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triggerHeader",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fff7ed"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ffedd5"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mqttHeader",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fef3c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#fde68a"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "conditionHeader",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ecfdf5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#d1fae5"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "apiHeader",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#eff6ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#dbeafe"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scriptHeader",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f5f3ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ede9fe"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dbHeader",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fff1f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ffe4e6"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "nodeShadow",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 6,
    stdDeviation: 10,
    floodColor: "#0f172a",
    floodOpacity: 0.12
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "panelShadow",
    x: "-5%",
    y: "-5%",
    width: "110%",
    height: "110%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 12,
    floodColor: "#0f172a",
    floodOpacity: 0.08
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "minimapShadow",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 10,
    floodColor: "#0f172a",
    floodOpacity: 0.15
  }))), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "dotGrid",
    width: 24,
    height: 24,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.2,
    fill: "#cbd5e1",
    fillOpacity: 0.45
  }))), _pattern2 || (_pattern2 = /*#__PURE__*/React.createElement("pattern", {
    id: "miniDotGrid",
    width: 12,
    height: 12,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.6,
    fill: "#94a3b8",
    fillOpacity: 0.4
  }))), _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "connArrow",
    markerWidth: 10,
    markerHeight: 10,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#94a3b8"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    height: 900,
    fill: "#f1f5f9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    height: 64,
    fill: "url(#headerGrad)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 64,
    x2: 1400,
    y2: 64,
    stroke: "#e2e8f0",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 40,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 800,
    fill: "#ea580c"
  }, "Nod")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 40,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 800,
    fill: "#f97316"
  }, "Flo")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 22,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#ea580c"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 32,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#f97316"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 22,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#fb923c"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 32,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#fdba74"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(920, 18)",
    fill: "none",
    stroke: "#64748b",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4 L5 18 L17 18 L17 8 L13 4 Z",
    stroke: "#475569",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 4,
    x2: 9,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 12,
    x2: 13,
    y2: 18
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(960, 18)",
    fill: "none",
    stroke: "#64748b",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5 L11 14 M8 11 L11 14 L14 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16 L5 18 L17 18 L17 16"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1000, 18)",
    fill: "none",
    stroke: "#64748b",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14 L11 5 M8 8 L11 5 L14 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16 L5 18 L17 18 L17 16"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040, 18)",
    fill: "none",
    stroke: "#64748b",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8,5 18,11 8,17",
    fill: "#22c55e",
    stroke: "none"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1080, 18)",
    fill: "none",
    stroke: "#64748b",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7 L17 7 L16 19 L6 19 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4 L14 4 M9 4 L9 7 M13 4 L13 7"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 18,
    width: 220,
    height: 28,
    rx: 6,
    fill: "#f1f5f9",
    stroke: "#e2e8f0",
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 36,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#334155",
    textAnchor: "middle"
  }, "Temperature Alert Flow")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1340,
    cy: 32,
    r: 16,
    fill: "#fdba74"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 1340,
    y: 37,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "EN")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1280,
    cy: 32,
    r: 16,
    fill: "#e2e8f0"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 1280,
    y: 37,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#64748b",
    textAnchor: "middle"
  }, "?")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 65,
    width: 260,
    height: 835,
    fill: "url(#sidebarGrad)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 65,
    x2: 260,
    y2: 900,
    stroke: "#e2e8f0",
    strokeWidth: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 82,
    width: 228,
    height: 40,
    rx: 8,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 102,
    r: 6,
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 106,
    x2: 45,
    y2: 111,
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 106,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fill: "#94a3b8"
  }, "Search Components")), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 140)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 236,
    height: 40,
    rx: 8,
    fill: "#fff7ed"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 12,
    fill: "#fdba74"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fill: "#fff",
    textAnchor: "middle"
  }, "T"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#334155"
  }, "Tag Read/Write"), /*#__PURE__*/React.createElement("path", {
    d: "M220 16 L228 20 L220 24",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 48)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 236,
    height: 40,
    rx: 8,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 12,
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fill: "#fff",
    textAnchor: "middle"
  }, "E"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#475569"
  }, "EMS"), /*#__PURE__*/React.createElement("path", {
    d: "M220 16 L228 20 L220 24",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 96)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 236,
    height: 40,
    rx: 8,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 12,
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fill: "#fff",
    textAnchor: "middle"
  }, "M"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#475569"
  }, "MES"), /*#__PURE__*/React.createElement("path", {
    d: "M220 16 L228 20 L220 24",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 144)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 236,
    height: 40,
    rx: 8,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 12,
    fill: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fill: "#fff",
    textAnchor: "middle"
  }, "P"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#475569"
  }, "Print"), /*#__PURE__*/React.createElement("path", {
    d: "M220 16 L228 20 L220 24",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 192)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 236,
    height: 40,
    rx: 8,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 12,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fill: "#fff",
    textAnchor: "middle"
  }, "\u26A1"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#475569"
  }, "Trigger"), /*#__PURE__*/React.createElement("path", {
    d: "M220 16 L228 20 L220 24",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 240)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 236,
    height: 40,
    rx: 8,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 12,
    fill: "#64748b"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fill: "#fff",
    textAnchor: "middle"
  }, "\u25C8"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#475569"
  }, "Common"), /*#__PURE__*/React.createElement("path", {
    d: "M220 16 L228 20 L220 24",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 288)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 236,
    height: 40,
    rx: 8,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 12,
    fill: "#06b6d4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#fff",
    textAnchor: "middle"
  }, "API"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#475569"
  }, "API Services"), /*#__PURE__*/React.createElement("path", {
    d: "M220 16 L228 20 L220 24",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 336)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 236,
    height: 40,
    rx: 8,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 12,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fill: "#fff",
    textAnchor: "middle"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#475569"
  }, "Stats"), /*#__PURE__*/React.createElement("path", {
    d: "M220 16 L228 20 L220 24",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 384)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 236,
    height: 40,
    rx: 8,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 12,
    fill: "#f97316"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fill: "#fff",
    textAnchor: "middle"
  }, "\u23F1"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#475569"
  }, "Timers"), /*#__PURE__*/React.createElement("path", {
    d: "M220 16 L228 20 L220 24",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 432)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 236,
    height: 40,
    rx: 8,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 12,
    fill: "#6366f1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fill: "#fff",
    textAnchor: "middle"
  }, "Js"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#475569"
  }, "Scripting"), /*#__PURE__*/React.createElement("path", {
    d: "M220 16 L228 20 L220 24",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 480)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 236,
    height: 40,
    rx: 8,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 12,
    fill: "#14b8a6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fill: "#fff",
    textAnchor: "middle"
  }, "[ ]"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#475569"
  }, "Array"), /*#__PURE__*/React.createElement("path", {
    d: "M220 16 L228 20 L220 24",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 236,
    height: 40,
    rx: 8,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 12,
    fill: "#ec4899"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fill: "#fff",
    textAnchor: "middle"
  }, "\u0192"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#475569"
  }, "Expressions"), /*#__PURE__*/React.createElement("path", {
    d: "M220 16 L228 20 L220 24",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 576)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 236,
    height: 40,
    rx: 8,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 12,
    fill: "#84cc16"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fill: "#fff",
    textAnchor: "middle"
  }, "\u2699"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#475569"
  }, "Services"), /*#__PURE__*/React.createElement("path", {
    d: "M220 16 L228 20 L220 24",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 624)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 236,
    height: 40,
    rx: 8,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 12,
    fill: "#78716c"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fill: "#fff",
    textAnchor: "middle"
  }, "\uD83D\uDCC4"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#475569"
  }, "Files"), /*#__PURE__*/React.createElement("path", {
    d: "M220 16 L228 20 L220 24",
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 65,
    width: 1139,
    height: 835,
    fill: "url(#canvasGrad)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 65,
    width: 1139,
    height: 835,
    fill: "url(#dotGrid)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560 320 C620 320, 620 320, 680 320",
    stroke: "#94a3b8",
    strokeWidth: 2.5,
    fill: "none",
    markerEnd: "url(#connArrow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M860 320 C920 320, 920 320, 980 320",
    stroke: "#94a3b8",
    strokeWidth: 2.5,
    fill: "none",
    markerEnd: "url(#connArrow)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1180 320 C1240 320, 1200 440, 1160 460",
    stroke: "#22c55e",
    strokeWidth: 2.5,
    fill: "none",
    markerEnd: "url(#connArrow)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1180 320 C1240 320, 1260 240, 1220 220",
    stroke: "#3b82f6",
    strokeWidth: 2.5,
    fill: "none",
    markerEnd: "url(#connArrow)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M980 520 C1040 520, 1040 640, 1100 640",
    stroke: "#94a3b8",
    strokeWidth: 2.5,
    fill: "none",
    markerEnd: "url(#connArrow)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(380, 260)",
    filter: "url(#nodeShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 120,
    rx: 12,
    fill: "#ffffff",
    stroke: "#fdba74",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 38,
    rx: 12,
    fill: "url(#triggerHeader)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28,
    width: 180,
    height: 10,
    fill: "url(#triggerHeader)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "\u26A1 Trigger"), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 62,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#475569",
    textAnchor: "middle"
  }, "Interval: 5s"), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 82,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#475569",
    textAnchor: "middle"
  }, "Value: 72.4"), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 60,
    r: 6,
    fill: "#ea580c",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 64,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#64748b"
  }, "Output"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(680, 250)",
    filter: "url(#nodeShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 140,
    rx: 12,
    fill: "#ffffff",
    stroke: "#f59e0b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 38,
    rx: 12,
    fill: "url(#mqttHeader)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28,
    width: 180,
    height: 10,
    fill: "url(#mqttHeader)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#92400e",
    textAnchor: "middle"
  }, "\uD83D\uDCE1 MQTT Subscribe"), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 62,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#475569",
    textAnchor: "middle"
  }, "Topic:"), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 82,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#b45309",
    textAnchor: "middle"
  }, "sensors/temp"), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 108,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#64748b",
    textAnchor: "middle"
  }, "QoS: 1"), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 60,
    r: 6,
    fill: "#f59e0b",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: -38,
    y: 64,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#64748b"
  }, "Input"), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 60,
    r: 6,
    fill: "#f59e0b",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 64,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#64748b"
  }, "Message"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(980, 250)",
    filter: "url(#nodeShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 140,
    rx: 12,
    fill: "#ffffff",
    stroke: "#10b981",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 38,
    rx: 12,
    fill: "url(#conditionHeader)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28,
    width: 200,
    height: 10,
    fill: "url(#conditionHeader)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#065f46",
    textAnchor: "middle"
  }, "\u25C7 Condition"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 62,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#475569",
    textAnchor: "middle"
  }, "temp &gt; 75\xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 82,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#475569",
    textAnchor: "middle"
  }, "Operator: Greater Than"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 108,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#22c55e",
    fontWeight: 600,
    textAnchor: "middle"
  }, "Current: TRUE"), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 60,
    r: 6,
    fill: "#10b981",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: -38,
    y: 64,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#64748b"
  }, "Input"), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 80,
    r: 6,
    fill: "#10b981",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 216,
    y: 84,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#64748b"
  }, "True"), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 40,
    r: 6,
    fill: "#10b981",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 216,
    y: 44,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#64748b"
  }, "False"))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1220, 170)",
    filter: "url(#nodeShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 100,
    rx: 12,
    fill: "#ffffff",
    stroke: "#3b82f6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 38,
    rx: 12,
    fill: "url(#apiHeader)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28,
    width: 170,
    height: 10,
    fill: "url(#apiHeader)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#1e40af",
    textAnchor: "middle"
  }, "\uD83C\uDF10 REST API"), /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 62,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#475569",
    textAnchor: "middle"
  }, "POST /api/alert"), /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 82,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#64748b",
    textAnchor: "middle"
  }, "Status: Ready"), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 50,
    r: 6,
    fill: "#3b82f6",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: -38,
    y: 54,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#64748b"
  }, "Input"))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(980, 460)",
    filter: "url(#nodeShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 120,
    rx: 12,
    fill: "#ffffff",
    stroke: "#8b5cf6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 38,
    rx: 12,
    fill: "url(#scriptHeader)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28,
    width: 180,
    height: 10,
    fill: "url(#scriptHeader)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#5b21b6",
    textAnchor: "middle"
  }, "JS JavaScript"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 50,
    width: 148,
    height: 48,
    rx: 6,
    fill: "#f5f3ff",
    stroke: "#ddd6fe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 66,
    fontFamily: "'Fira Code', monospace",
    fontSize: 9,
    fill: "#6d28d9",
    textAnchor: "middle"
  }, "msg.level = \"HIGH\";"), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 82,
    fontFamily: "'Fira Code', monospace",
    fontSize: 9,
    fill: "#6d28d9",
    textAnchor: "middle"
  }, "return msg;"), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 60,
    r: 6,
    fill: "#8b5cf6",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: -38,
    y: 64,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#64748b"
  }, "Input"), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 60,
    r: 6,
    fill: "#8b5cf6",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 64,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#64748b"
  }, "Output"))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1100, 580)",
    filter: "url(#nodeShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 120,
    rx: 12,
    fill: "#ffffff",
    stroke: "#f43f5e",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 38,
    rx: 12,
    fill: "url(#dbHeader)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28,
    width: 200,
    height: 10,
    fill: "url(#dbHeader)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 24,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#9f1239",
    textAnchor: "middle"
  }, "\uD83D\uDDC4 Database Logger"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 62,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#475569",
    textAnchor: "middle"
  }, "Table: temp_alerts"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 82,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#475569",
    textAnchor: "middle"
  }, "Connection: MySQL-01"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 104,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#22c55e",
    fontWeight: 600,
    textAnchor: "middle"
  }, "Last log: 14:32:08"), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 60,
    r: 6,
    fill: "#f43f5e",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: -38,
    y: 64,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#64748b"
  }, "Input"), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 60,
    r: 6,
    fill: "#f43f5e",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 216,
    y: 64,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#64748b"
  }, "Output"))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(280, 820)",
    filter: "url(#panelShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 200,
    rx: 10,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#f8fafc",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8 A6 6 0 0 0 8 8 M8 8 L8 5 M8 8 L11 8",
    fill: "none",
    stroke: "#64748b",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 40)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#f8fafc",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8 A6 6 0 0 1 16 8 M16 8 L16 5 M16 8 L13 8",
    fill: "none",
    stroke: "#64748b",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 68)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#f8fafc",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 17,
    y2: 12,
    stroke: "#64748b",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 17,
    stroke: "#64748b",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 96)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#f8fafc",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 17,
    y2: 12,
    stroke: "#64748b",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 124)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#f8fafc",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    fill: "none",
    stroke: "#64748b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 9,
    x2: 6,
    y2: 6,
    stroke: "#64748b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 6,
    x2: 9,
    y2: 6,
    stroke: "#64748b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 9,
    x2: 18,
    y2: 6,
    stroke: "#64748b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 6,
    x2: 15,
    y2: 6,
    stroke: "#64748b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 15,
    x2: 6,
    y2: 18,
    stroke: "#64748b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 9,
    y2: 18,
    stroke: "#64748b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 15,
    x2: 18,
    y2: 18,
    stroke: "#64748b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 18,
    x2: 15,
    y2: 18,
    stroke: "#64748b",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 152)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#f8fafc",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 10,
    height: 8,
    rx: 1,
    fill: "none",
    stroke: "#64748b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11 L9 8 A3 3 0 0 1 15 8 L15 11",
    fill: "none",
    stroke: "#64748b",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6, 180)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    rx: 4,
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 11,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9,
    fontWeight: 600,
    fill: "#475569",
    textAnchor: "middle"
  }, "100%")))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1160, 700)",
    filter: "url(#minimapShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 170,
    rx: 12,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 22,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 600,
    fill: "#475569",
    textAnchor: "middle"
  }, "Minimap"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 34,
    width: 188,
    height: 120,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 34,
    width: 188,
    height: 120,
    rx: 8,
    fill: "url(#miniDotGrid)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 58,
    width: 24,
    height: 16,
    rx: 3,
    fill: "#fdba74",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 58,
    width: 24,
    height: 16,
    rx: 3,
    fill: "#f59e0b",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 58,
    width: 24,
    height: 16,
    rx: 3,
    fill: "#10b981",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 40,
    width: 24,
    height: 16,
    rx: 3,
    fill: "#3b82f6",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 94,
    width: 24,
    height: 16,
    rx: 3,
    fill: "#8b5cf6",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 110,
    width: 24,
    height: 16,
    rx: 3,
    fill: "#f43f5e",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 42,
    width: 100,
    height: 80,
    fill: "none",
    stroke: "#ea580c",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 66 L66 66",
    stroke: "#94a3b8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 66 L102 66",
    stroke: "#94a3b8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 66 L138 50",
    stroke: "#3b82f6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 74 L126 102",
    stroke: "#22c55e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 110 L138 118",
    stroke: "#94a3b8",
    strokeWidth: 1
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 876,
    width: 1139,
    height: 24,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 892,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#64748b"
  }, "6 nodes \u2022 5 edges \u2022 Last saved: 14:31:55")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 1360,
    y: 892,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#22c55e",
    textAnchor: "end"
  }, "\u25CF Active")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeEditor);
export default __webpack_public_path__ + "static/media/node_editor.52860107f725b905c379b3507e642920.svg";
export { ForwardRef as ReactComponent };